import BaseDialog from "@/components/BaseDialog";

// 查看&编辑 权限
export function checkRoleInfoModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./roleInfoModal.vue'),
        options: {
            width: '"60%',
            title: '查看角色',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
// 添加配置数据
export function addSqlDataModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./addSqlDataModal.vue'),
        options: {
            width: '700px',
            title: '添加数据',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

